import { useMemo } from "react";
import useCurrencyConversions from "hooks/useCurrencyConversions";

export default function useMultiCurrencyConversions({ from, toList, amount = 1 }) {
  const hooks = toList.map((to) => useCurrencyConversions({ from, to, amount }));
  const loading = hooks.some((h) => h.loading);
  const error = hooks.find((h) => h.error)?.error || null;

  const data = useMemo(() => {
    return toList.reduce((acc, currency, i) => {
      const hook = hooks[i];
      if (!hook?.data) return acc;

      acc[currency] = {
        to: currency,
        ...hook.data,
      };

      return acc;
    }, {});
  }, [hooks]);

  return { loading, error, data };
}
